import React from "react"
import PropTypes from "prop-types"

import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

// component for rendering an enum, given a display key
export const EnumDisplayCell = ({ item = {}, displayKey = "label", transformFunction = (val) => val, ...props }) => (
    <CellWrapper {...props}>{transformFunction(item[displayKey])}</CellWrapper>
)

EnumDisplayCell.propTypes = {
    transformFunction: PropTypes.func.isRequired,
    displayKey: PropTypes.string,
    item: PropTypes.object,
}
